import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

// DS
import { Col, Image, VertTypography, VertButton } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Cart/CartEmptyStyles.less';
import { emptyCart } from 'Constants/Constants';

// CART EMPTY COMPONENT
const CartEmpty = ({
    icon=emptyCart,
    title=`Seu carrinho está vazio!`,
    description='Aproveite nossos produtos e serviços e resgate agora mesmo!',
    openCloseHandler,
    isGift = false
  }) => {

  /* Hooks */
  const navigate = useNavigate();

  /* Handlers */
  const goToProductsHandler = () => {
    navigate('/search/1/filter/JTdCJTIyc29ydCUyMiUzQSUyMlNDT1JFJTIyJTdE');

    if(openCloseHandler) {
      openCloseHandler();
    };
  };

  /* Renders */
  return (
    <Col className="cart-empty-wrapper">
      <Col className="cart-empty-content">
        <Image className="item-image" src={icon} alt={title} preview={false} />

        <Col className="cart-empty-text">
          <VertTypography.Title>{title}</VertTypography.Title>

          <VertTypography.Paragraph>{description}</VertTypography.Paragraph>
        </Col>
        {!isGift && (
          <VertButton type="highlight" onClick={goToProductsHandler}>
            Ver produtos
          </VertButton>
        )}
      </Col>
    </Col>
  );
};

CartEmpty.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  openCloseHandler: PropTypes.func,
};

export default CartEmpty;
